import type { ComponentType } from 'react'
import { CircleDollarSign, Gift } from 'lucide-react'
import { PremiumStarIcon } from '@/components/common/PremiumStarIcon'
import { Label, RadioCardGroup } from '@teach/ui'
import type { SalesModel } from '../../lib/salesModel'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { ExperimentalNote } from '../shared/ExperimentalNote'

interface Props {
  value: SalesModel
  onChange: (next: SalesModel) => void
  disabled: boolean
  /** Экспериментальный доступ: курс может быть только бесплатным (ответ бэка п.9). */
  freeOnly?: boolean
}

const OPTIONS: {
  id: SalesModel
  label: 'salesSubscription' | 'salesStandalone' | 'salesFree'
  icon: ComponentType<{ className?: string; strokeWidth?: string | number }>
}[] = [
  { id: 'subscription', label: 'salesSubscription', icon: PremiumStarIcon },
  { id: 'standalone', label: 'salesStandalone', icon: CircleDollarSign },
  { id: 'free', label: 'salesFree', icon: Gift },
]

export const SalesModelPicker = ({ value, onChange, disabled, freeOnly = false }: Props) => {
  const m = useMessages(messages)
  return (
    <div className="space-y-3">
      <Label>{m.salesModel}</Label>
      <RadioCardGroup
        columns={3}
        // Бета-автор публикует только по ссылке, и сервер платный курс у него не
        // проверяет — платные режимы гасим здесь, пока не появится модерация.
        options={OPTIONS.map((o) => ({
          ...o,
          label: m[o.label],
          disabled: freeOnly && o.id !== 'free',
        }))}
        value={value}
        onChange={(id) => onChange(id as SalesModel)}
        disabled={disabled}
        // На телефоне три карточки в ряд резали подписи до «В подп…» — там одна под другой.
        className="grid-cols-1 sm:grid-cols-3 [&_button]:py-4 [&_button]:text-base [&_svg]:size-5"
      />
      {/* Плашка отстоит от карточек так же, как секции настроек друг от друга (24px). */}
      {freeOnly ? (
        <div className="pt-3">
          <ExperimentalNote title={m.salesFreeOnlyTitle} body={m.salesFreeOnly} />
        </div>
      ) : null}
    </div>
  )
}
